import { createSlice } from "@reduxjs/toolkit";
import { apiGetTicketingConfig } from "../api/ticketingApi";

// Minimal ticketing state: the pilot flag (drives the tile/routes) + the
// customer's current seat hold (carried from seat selection into checkout).
const ticketingSlice = createSlice({
  name: "ticketing",
  initialState: { enabled: false, configLoaded: false, currentHold: null },
  reducers: {
    setTicketingConfig: (s, a) => {
      s.enabled = !!a.payload?.enabled;
      s.configLoaded = true;
    },
    setCurrentHold: (s, a) => {
      s.currentHold = a.payload;
    },
    clearCurrentHold: (s) => {
      s.currentHold = null;
    },
  },
});

export const { setTicketingConfig, setCurrentHold, clearCurrentHold } = ticketingSlice.actions;

export const fetchTicketingConfig = () => async (dispatch) => {
  try {
    const data = await apiGetTicketingConfig();
    dispatch(setTicketingConfig(data));
  } catch {
    dispatch(setTicketingConfig({ enabled: false }));
  }
};

export default ticketingSlice.reducer;
